<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import { BButton, BIcon } from '@barbanet/ui-kit/components'

import { usePermission } from '../composables/use-permission'

const route = useRoute()
const { hasPermission } = usePermission()

const showContent = ref(true)

const routePermission = computed(() => {
	if (route.meta.public || route.meta.publicOnly) {
		return null
	}

	const permissionParts: string[] = []
	route.matched.forEach((routeRecord) => {
		if (
			routeRecord.meta &&
			routeRecord.meta.permissionKey &&
			typeof routeRecord.meta.permissionKey === 'string' &&
			routeRecord.meta.permissionKey.length
		) {
			permissionParts.push(routeRecord.meta.permissionKey)
		}
	})

	return permissionParts.length ? permissionParts.join('_') : null
})

// TODO: handle workspace change
watch(routePermission, (value) => {
	showContent.value = value === null ? true : hasPermission(value).value
})
</script>

<template>
	<slot v-if="showContent" />

	<div
		v-else
		class="w-dvh h-dvh flex flex-col items-center justify-center gap-4"
	>
		<BIcon
			icon="biometric-access"
			color="error"
			size="100"
		/>

		<h1 class="text-heading-3 text-error">Access Denied</h1>

		<BButton
			text="Go back"
			variant="tonal"
			append-icon="arrow-left-02"
			@click="$router.back()"
		/>
	</div>
</template>
